export default "__VITE_ASSET__001a4f1c__"